'use client';

import SiteBanner from '@/components/common/banner/SiteBanner';
import { HOME_BANNER_POSITION_BY_TYPE } from '@/constants/banner';
import type { BannerLayoutType } from '@/types/banner';

interface BannerProps {
  type: BannerLayoutType;
}

const Banner = ({ type }: BannerProps) => {
  const layoutClassName =
    type === 'horizontal'
      ? 'hidden md:block w-full overflow-hidden'
      : 'hidden lg:block max-w-full overflow-hidden';

  return (
    <SiteBanner
      positionId={HOME_BANNER_POSITION_BY_TYPE[type]}
      layout={type}
      className={`flex-none shrink-0 pb-5 relative ${layoutClassName}`}
    />
  );
};

export default Banner;
